<template>
  <div class="mask" v-if="maskFlag">
  </div>
</template>

<script>
  export default {
    name: "maskDiv",
    data() {
      return {
        maskFlag: false,
      }
    },
    watch: {}
  }
</script>

<style scoped lang="scss">
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 1001;
    background: rgba(0, 0, 0, 0.7);
  }
</style>



// WEBPACK FOOTER //
// maskDiv.vue?b83d3114